module.exports = __webpack_public_path__ + "20250721160708/img/nodata.fbb1fa61.png";